import { Color, LuxButton, LuxIconSpinner } from '@lux/wardrobe-lib'
import { Dialog } from 'primereact/dialog'
import { useRef } from 'react'
import { useIntl } from 'react-intl'
import './DialogUploadPhoto.scss'
import { isMobile } from 'react-device-detect'

const DialogUploadPhoto = ({
    visible,
    onHide,
    projectName,
    onFileChange,
    multiple,
    modalLoading,
}) => {
    const componentClass = 'smart-modals-dialog-upload-photo'

    const intl = useIntl()
    // const isMobile = useWindowResize()
    const inputRef = useRef(null)
    const inputCaptureRef = useRef(null)

    const onSelect = () => {
        inputRef.current.click()
    }

    const onCaptureSelect = () => {
        inputCaptureRef.current.click()
    }

    return (
        <Dialog
            draggable={false}
            visible={visible}
            onHide={() => onHide()}
            style={{ width: '40vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}>
            {modalLoading && (
                <div className={`${componentClass}__spinner`}>
                    <LuxIconSpinner />
                </div>
            )}
            <div className={`${componentClass}__content`}>
                <div className={`${componentClass}__title text-bold`}>
                    {intl.formatMessage({
                        id: `modals.dialog.upload.photo.title`,
                        defaultMessage: 'Add Photo',
                    })}
                </div>
                <div className={`${componentClass}__description text-bold`}>
                    {intl.formatMessage({
                        id: `modals.dialog.upload.photo.description`,
                        defaultMessage: 'Select how you want to add photo',
                    })}
                </div>
                <div className={`${componentClass}__project-name text`}>{projectName}</div>

                <div className={`${componentClass}__footer`}>
                    <input
                        ref={inputRef}
                        type="file"
                        className="input-file-upload"
                        multiple={multiple}
                        onChange={onFileChange}
                        capture={false}
                        accept=".apng,.avif,.gif,.jpg,.jpeg,.jfif,.pjpeg,.pjp,.png,.svg,.webp,.bmp,.ico,.cur,.tif,.tiff.APNG,.AVIF,.GIF,.JPG,.JPEG,.JFIF,.PJPEG,.PJP,.PNG,.SVG,.WEBP,.BMP,.ICO,.CUR,.TIF,.TIFF"
                    />
                    <input
                        ref={inputCaptureRef}
                        type="file"
                        className="input-file-upload"
                        multiple={multiple}
                        onChange={onFileChange}
                        capture={isMobile}
                        accept=".apng,.avif,.gif,.jpg,.jpeg,.jfif,.pjpeg,.pjp,.png,.svg,.webp,.bmp,.ico,.cur,.tif,.tiff.APNG,.AVIF,.GIF,.JPG,.JPEG,.JFIF,.PJPEG,.PJP,.PNG,.SVG,.WEBP,.BMP,.ICO,.CUR,.TIF,.TIFF"
                    />
                    <LuxButton
                        text={intl.formatMessage({
                            id: 'modals.file.upload.load',
                            defaultMessage: 'Upload photo',
                        })}
                        variant="outlined"
                        onClick={onSelect}
                    />
                    {isMobile && (
                        <LuxButton
                            text={intl.formatMessage({
                                id: 'modals.file.upload.take',
                                defaultMessage: 'Take photo',
                            })}
                            color={Color.WARNING}
                            onClick={onCaptureSelect}
                        />
                    )}
                </div>
            </div>
        </Dialog>
    )
}

export default DialogUploadPhoto
